// Lead.tsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputBase,
  Typography,
  MenuItem,
  Select,
} from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ImportExportOutlinedIcon from "@mui/icons-material/ImportExportOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import KanbanBoard from "./Kanbanview";
import HistroyView from "./HistroyView";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../Redux/Store/Hooks";
import { LeadDataRead } from "../../../Redux/Slices/CRM/Leads/LeadViewdata/LeadData";
import "./Lead.scss";

const Lead = () => {
  const [view, setView] = useState("Kanban View");
  const dispatch = useDispatch();

  const { data: LeadData, isLoading: LeaddataLoading } = useAppSelector(
    (state) => state.LeadDataSlice
  );

  useEffect(() => {
    dispatch(LeadDataRead());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch(LeadDataRead());
  };

  return (
    <div className="lead-page">
      {/* Header */}
      <Box className="lead-header">
        <Typography sx={{ fontSize: "20px", fontWeight: 500, mb: 2 }}>
          Leads
        </Typography>

        {/* Actions */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <IconButton
            onClick={handleRefresh}
            sx={{
              backgroundColor: "#D9D9D9",
              "&:hover": { backgroundColor: "#e4e4e4" },
              width: 40,
              height: 40,
              borderRadius: "50%",
              color: "black",
            }}
          >
            <CachedOutlinedIcon sx={{ fontSize: 22 }} />
          </IconButton>

          <Box sx={{ display: "flex", alignItems: "center", width: 250 }}>
            <InputBase
              placeholder="Search"
              sx={{
                fontSize: 14,
                flex: 1,
                backgroundColor: "#F5F5F5",
                borderRadius: "12px",
                px: 1.5,
              }}
            />
          </Box>

          <IconButton
            sx={{
              backgroundColor: "#f0f0f0",
              "&:hover": { backgroundColor: "#e4e4e4" },
              width: 40,
              height: 40,
              borderRadius: "50%",
              color: "black",
            }}
          >
            <FilterAltOutlinedIcon sx={{ fontSize: 22 }} />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#D9D9D9",
              borderRadius: "16px",
              px: 1.5,
              py: 0.2,
              height: 36,
              minWidth: 160,
            }}
          >
            <Select
              value={view}
              onChange={(e) => setView(e.target.value)}
              variant="standard"
              disableUnderline
              IconComponent={ImportExportOutlinedIcon}
              sx={{
                color: "#575757",
                fontSize: "14px",
                fontWeight: 500,
                width: "100%",
              }}
            >
              <MenuItem value="Kanban View">Kanban View</MenuItem>
              <MenuItem value="History View">History View</MenuItem>
            </Select>
          </Box>

          <Button
            variant="contained"
            sx={{
              color: "#ffffff",
              backgroundColor: "#0094FF",
              textTransform: "none",
              borderRadius: "16px",
              px: 3,
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            + Create
          </Button>
        </Box>
      </Box>

      {/* Kanban / History View */}
      {view === "Kanban View" ? (
        <KanbanBoard LeadData={LeadData?.data} isLoading={LeaddataLoading} />
      ) : (
        <HistroyView LeadData={LeadData?.data} isLoading={LeaddataLoading} />
      )}
    </div>
  );
};

export default Lead;
